import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postAdminNewChat = (params) => {
  return axiosClient.post("/api/admin/im", params).then((r) => r.data);
};
